var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ota-app"},[_c('router-view',{key:_vm.reloadKey,on:{"changeLocale":_vm.changeLocale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }